import { AuthService } from './../services/auth-service/auth.service';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';

/* i used CanActivateFn because CanActivate is deprecated from the version 14.2 of angular */

export namespace authenticationGuard {
  export const canActivate: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const isAuthRoute = state.url.includes('auth');
    const isResetPasswordRoute = state.url.includes('reset-password');
    const isAuthenticated = authService.isAuthenticated();
    if (isAuthRoute && !isResetPasswordRoute && !isAuthenticated) {
      return true;
    }
    if (isAuthRoute && !isResetPasswordRoute && isAuthenticated) {
      router.navigate(['/accueil']);
      return false;
    }
    if (isResetPasswordRoute) {
      const queryParams = route.queryParams;
      const token = queryParams['token'];
      const email = queryParams['email'];
      const intervenant = queryParams['intervenant']
      if (token && email && intervenant) {
        return true;
      } else {
        router.navigate(['/auth/login']);
        return false;
      }
    }
    if (isAuthenticated) {
      return true;
    }
    router.navigate(['/auth/login']);
    return false;
  };
  export const canActivateChild: CanActivateChildFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) => canActivate(route, state);
}
